<template>
    <v-btn rounded="lg" color="#FFDF8C" :to="redirect"> {{ text }} </v-btn>
</template>

<script>
export default {
    name: "SolidButton",
    props: {
        text: String,
        redirect: String,
    },
};
</script>
